import { queryRef, executeQuery, mutationRef, executeMutation, validateArgs } from 'firebase/data-connect';

export const ContentType = {
  EMAIL: "EMAIL",
  INBOX: "INBOX",
  SEQUENCE: "SEQUENCE",
  SMS: "SMS",
  WEB: "WEB",
}

export const MessageChannel = {
  DM: "DM",
  GROUP: "GROUP",
}

export const PhoneNumberProvider = {
  TELNYX: "TELNYX",
  TWILIO: "TWILIO",
  VONAGE: "VONAGE",
}

export const PhoneType = {
  PHONE: "PHONE",
  USERID: "USERID",
}

export const RightType = {
  READ_ORGANIZATION: "READ_ORGANIZATION",
  UPDATE_ORGANIZATION: "UPDATE_ORGANIZATION",
  INBOX_ACCESS: "INBOX_ACCESS",
  ADMIN: "ADMIN",
  SYSTEM_ADMIN: "SYSTEM_ADMIN",
}

export const ScheduleType = {
  EMAIL: "EMAIL",
  SMS: "SMS",
  SURVEY: "SURVEY",
}

export const SpecialMessageType = {
  WELCOME: "WELCOME",
  GETTING_STARTED: "GETTING_STARTED",
}

export const connectorConfig = {
  connector: 'copilot',
  service: 'copilot',
  location: 'us-east4'
};

export const getAllOrganizationTimesRef = (dc) => {
  const { dc: dcInstance} = validateArgs(connectorConfig, dc, undefined);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetAllOrganizationTimes');
}
getAllOrganizationTimesRef.operationName = 'GetAllOrganizationTimes';

export function getAllOrganizationTimes(dc) {
  return executeQuery(getAllOrganizationTimesRef(dc));
}

export const getOrganizationRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetOrganization', inputVars);
}
getOrganizationRef.operationName = 'GetOrganization';

export function getOrganization(dcOrVars, vars) {
  return executeQuery(getOrganizationRef(dcOrVars, vars));
}

export const getParentOrganizationsRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetParentOrganizations', inputVars);
}
getParentOrganizationsRef.operationName = 'GetParentOrganizations';

export function getParentOrganizations(dcOrVars, vars) {
  return executeQuery(getParentOrganizationsRef(dcOrVars, vars));
}

export const getOrganizationBySlugRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetOrganizationBySlug', inputVars);
}
getOrganizationBySlugRef.operationName = 'GetOrganizationBySlug';

export function getOrganizationBySlug(dcOrVars, vars) {
  return executeQuery(getOrganizationBySlugRef(dcOrVars, vars));
}

export const getOrganizationStatsRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetOrganizationStats', inputVars);
}
getOrganizationStatsRef.operationName = 'GetOrganizationStats';

export function getOrganizationStats(dcOrVars, vars) {
  return executeQuery(getOrganizationStatsRef(dcOrVars, vars));
}

export const checkOrganizationSlugRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'CheckOrganizationSlug', inputVars);
}
checkOrganizationSlugRef.operationName = 'CheckOrganizationSlug';

export function checkOrganizationSlug(dcOrVars, vars) {
  return executeQuery(checkOrganizationSlugRef(dcOrVars, vars));
}

export const updateOrganizationRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'UpdateOrganization', inputVars);
}
updateOrganizationRef.operationName = 'UpdateOrganization';

export function updateOrganization(dcOrVars, vars) {
  return executeMutation(updateOrganizationRef(dcOrVars, vars));
}

export const updateOrganizationProvidersRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'UpdateOrganizationProviders', inputVars);
}
updateOrganizationProvidersRef.operationName = 'UpdateOrganizationProviders';

export function updateOrganizationProviders(dcOrVars, vars) {
  return executeMutation(updateOrganizationProvidersRef(dcOrVars, vars));
}

export const createOrganizationRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'CreateOrganization', inputVars);
}
createOrganizationRef.operationName = 'CreateOrganization';

export function createOrganization(dcOrVars, vars) {
  return executeMutation(createOrganizationRef(dcOrVars, vars));
}

export const softDeleteOrganizationRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'SoftDeleteOrganization', inputVars);
}
softDeleteOrganizationRef.operationName = 'SoftDeleteOrganization';

export function softDeleteOrganization(dcOrVars, vars) {
  return executeMutation(softDeleteOrganizationRef(dcOrVars, vars));
}

export const getLatestInboxMessagesRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetLatestInboxMessages', inputVars);
}
getLatestInboxMessagesRef.operationName = 'GetLatestInboxMessages';

export function getLatestInboxMessages(dcOrVars, vars) {
  return executeQuery(getLatestInboxMessagesRef(dcOrVars, vars));
}

export const getMessagesByPhoneIdRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetMessagesByPhoneId', inputVars);
}
getMessagesByPhoneIdRef.operationName = 'GetMessagesByPhoneId';

export function getMessagesByPhoneId(dcOrVars, vars) {
  return executeQuery(getMessagesByPhoneIdRef(dcOrVars, vars));
}

export const markMessagesProcessedRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'MarkMessagesProcessed', inputVars);
}
markMessagesProcessedRef.operationName = 'MarkMessagesProcessed';

export function markMessagesProcessed(dcOrVars, vars) {
  return executeMutation(markMessagesProcessedRef(dcOrVars, vars));
}

export const markMessageFollowUpRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'MarkMessageFollowUp', inputVars);
}
markMessageFollowUpRef.operationName = 'MarkMessageFollowUp';

export function markMessageFollowUp(dcOrVars, vars) {
  return executeMutation(markMessageFollowUpRef(dcOrVars, vars));
}

export const markMessagesUnprocessedRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'MarkMessagesUnprocessed', inputVars);
}
markMessagesUnprocessedRef.operationName = 'MarkMessagesUnprocessed';

export function markMessagesUnprocessed(dcOrVars, vars) {
  return executeMutation(markMessagesUnprocessedRef(dcOrVars, vars));
}

export const markThreadFollowUpRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'MarkThreadFollowUp', inputVars);
}
markThreadFollowUpRef.operationName = 'MarkThreadFollowUp';

export function markThreadFollowUp(dcOrVars, vars) {
  return executeMutation(markThreadFollowUpRef(dcOrVars, vars));
}

export const addViewerRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'AddViewer', inputVars);
}
addViewerRef.operationName = 'AddViewer';

export function addViewer(dcOrVars, vars) {
  return executeMutation(addViewerRef(dcOrVars, vars));
}

export const getScheduleRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetSchedule', inputVars);
}
getScheduleRef.operationName = 'GetSchedule';

export function getSchedule(dcOrVars, vars) {
  return executeQuery(getScheduleRef(dcOrVars, vars));
}

export const getScheduleByIdRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetScheduleById', inputVars);
}
getScheduleByIdRef.operationName = 'GetScheduleById';

export function getScheduleById(dcOrVars, vars) {
  return executeQuery(getScheduleByIdRef(dcOrVars, vars));
}

export const createScheduleRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'CreateSchedule', inputVars);
}
createScheduleRef.operationName = 'CreateSchedule';

export function createSchedule(dcOrVars, vars) {
  return executeMutation(createScheduleRef(dcOrVars, vars));
}

export const updateScheduleRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'UpdateSchedule', inputVars);
}
updateScheduleRef.operationName = 'UpdateSchedule';

export function updateSchedule(dcOrVars, vars) {
  return executeMutation(updateScheduleRef(dcOrVars, vars));
}

export const softDeleteScheduleRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'SoftDeleteSchedule', inputVars);
}
softDeleteScheduleRef.operationName = 'SoftDeleteSchedule';

export function softDeleteSchedule(dcOrVars, vars) {
  return executeMutation(softDeleteScheduleRef(dcOrVars, vars));
}

export const markScheduleAsSendNowRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'MarkScheduleAsSendNow', inputVars);
}
markScheduleAsSendNowRef.operationName = 'MarkScheduleAsSendNow';

export function markScheduleAsSendNow(dcOrVars, vars) {
  return executeMutation(markScheduleAsSendNowRef(dcOrVars, vars));
}

export const listSpecialMessagesRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'ListSpecialMessages', inputVars);
}
listSpecialMessagesRef.operationName = 'ListSpecialMessages';

export function listSpecialMessages(dcOrVars, vars) {
  return executeQuery(listSpecialMessagesRef(dcOrVars, vars));
}

export const listPublicSpecialMessagesRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'ListPublicSpecialMessages', inputVars);
}
listPublicSpecialMessagesRef.operationName = 'ListPublicSpecialMessages';

export function listPublicSpecialMessages(dcOrVars, vars) {
  return executeQuery(listPublicSpecialMessagesRef(dcOrVars, vars));
}

export const upsertSpecialMessageRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'UpsertSpecialMessage', inputVars);
}
upsertSpecialMessageRef.operationName = 'UpsertSpecialMessage';

export function upsertSpecialMessage(dcOrVars, vars) {
  return executeMutation(upsertSpecialMessageRef(dcOrVars, vars));
}

export const saveTokenRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'SaveToken', inputVars);
}
saveTokenRef.operationName = 'SaveToken';

export function saveToken(dcOrVars, vars) {
  return executeMutation(saveTokenRef(dcOrVars, vars));
}

export const deleteTokenRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'DeleteToken', inputVars);
}
deleteTokenRef.operationName = 'DeleteToken';

export function deleteToken(dcOrVars, vars) {
  return executeMutation(deleteTokenRef(dcOrVars, vars));
}

export const getTokensRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetTokens', inputVars);
}
getTokensRef.operationName = 'GetTokens';

export function getTokens(dcOrVars, vars) {
  return executeQuery(getTokensRef(dcOrVars, vars));
}

export const getTokensByOrganizationRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetTokensByOrganization', inputVars);
}
getTokensByOrganizationRef.operationName = 'GetTokensByOrganization';

export function getTokensByOrganization(dcOrVars, vars) {
  return executeQuery(getTokensByOrganizationRef(dcOrVars, vars));
}

export const meRef = (dc) => {
  const { dc: dcInstance} = validateArgs(connectorConfig, dc, undefined);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'Me');
}
meRef.operationName = 'Me';

export function me(dc) {
  return executeQuery(meRef(dc));
}

export const getUserByEmailRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetUserByEmail', inputVars);
}
getUserByEmailRef.operationName = 'GetUserByEmail';

export function getUserByEmail(dcOrVars, vars) {
  return executeQuery(getUserByEmailRef(dcOrVars, vars));
}

export const upsertUserRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'UpsertUser', inputVars);
}
upsertUserRef.operationName = 'UpsertUser';

export function upsertUser(dcOrVars, vars) {
  return executeMutation(upsertUserRef(dcOrVars, vars));
}

export const softDeleteUserRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'SoftDeleteUser', inputVars);
}
softDeleteUserRef.operationName = 'SoftDeleteUser';

export function softDeleteUser(dcOrVars, vars) {
  return executeMutation(softDeleteUserRef(dcOrVars, vars));
}

export const saveClientNotificationTokenRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'SaveClientNotificationToken', inputVars);
}
saveClientNotificationTokenRef.operationName = 'SaveClientNotificationToken';

export function saveClientNotificationToken(dcOrVars, vars) {
  return executeMutation(saveClientNotificationTokenRef(dcOrVars, vars));
}

export const deleteClientNotificationTokenRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'DeleteClientNotificationToken', inputVars);
}
deleteClientNotificationTokenRef.operationName = 'DeleteClientNotificationToken';

export function deleteClientNotificationToken(dcOrVars, vars) {
  return executeMutation(deleteClientNotificationTokenRef(dcOrVars, vars));
}

export const getClientNotificationTokensRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetClientNotificationTokens', inputVars);
}
getClientNotificationTokensRef.operationName = 'GetClientNotificationTokens';

export function getClientNotificationTokens(dcOrVars, vars) {
  return executeQuery(getClientNotificationTokensRef(dcOrVars, vars));
}

export const getClientNotificationTokensByTargetRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetClientNotificationTokensByTarget', inputVars);
}
getClientNotificationTokensByTargetRef.operationName = 'GetClientNotificationTokensByTarget';

export function getClientNotificationTokensByTarget(dcOrVars, vars) {
  return executeQuery(getClientNotificationTokensByTargetRef(dcOrVars, vars));
}

export const getContentListRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetContentList', inputVars);
}
getContentListRef.operationName = 'GetContentList';

export function getContentList(dcOrVars, vars) {
  return executeQuery(getContentListRef(dcOrVars, vars));
}

export const getContentRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetContent', inputVars);
}
getContentRef.operationName = 'GetContent';

export function getContent(dcOrVars, vars) {
  return executeQuery(getContentRef(dcOrVars, vars));
}

export const addContentRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'AddContent', inputVars);
}
addContentRef.operationName = 'AddContent';

export function addContent(dcOrVars, vars) {
  return executeMutation(addContentRef(dcOrVars, vars));
}

export const updateContentRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'UpdateContent', inputVars);
}
updateContentRef.operationName = 'UpdateContent';

export function updateContent(dcOrVars, vars) {
  return executeMutation(updateContentRef(dcOrVars, vars));
}

export const softDeleteContentRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'SoftDeleteContent', inputVars);
}
softDeleteContentRef.operationName = 'SoftDeleteContent';

export function softDeleteContent(dcOrVars, vars) {
  return executeMutation(softDeleteContentRef(dcOrVars, vars));
}

export const createLoginCodeRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'CreateLoginCode', inputVars);
}
createLoginCodeRef.operationName = 'CreateLoginCode';

export function createLoginCode(dcOrVars, vars) {
  return executeMutation(createLoginCodeRef(dcOrVars, vars));
}

export const incrementLoginCodeAttemptsRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'IncrementLoginCodeAttempts', inputVars);
}
incrementLoginCodeAttemptsRef.operationName = 'IncrementLoginCodeAttempts';

export function incrementLoginCodeAttempts(dcOrVars, vars) {
  return executeMutation(incrementLoginCodeAttemptsRef(dcOrVars, vars));
}

export const deleteLoginCodeRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'DeleteLoginCode', inputVars);
}
deleteLoginCodeRef.operationName = 'DeleteLoginCode';

export function deleteLoginCode(dcOrVars, vars) {
  return executeMutation(deleteLoginCodeRef(dcOrVars, vars));
}

export const getLoginCodeByEmailRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetLoginCodeByEmail', inputVars);
}
getLoginCodeByEmailRef.operationName = 'GetLoginCodeByEmail';

export function getLoginCodeByEmail(dcOrVars, vars) {
  return executeQuery(getLoginCodeByEmailRef(dcOrVars, vars));
}

export const clearLoginCodesRef = (dc) => {
  const { dc: dcInstance} = validateArgs(connectorConfig, dc, undefined);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'ClearLoginCodes');
}
clearLoginCodesRef.operationName = 'ClearLoginCodes';

export function clearLoginCodes(dc) {
  return executeMutation(clearLoginCodesRef(dc));
}

export const getMembersRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetMembers', inputVars);
}
getMembersRef.operationName = 'GetMembers';

export function getMembers(dcOrVars, vars) {
  return executeQuery(getMembersRef(dcOrVars, vars));
}

export const getMemberRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetMember', inputVars);
}
getMemberRef.operationName = 'GetMember';

export function getMember(dcOrVars, vars) {
  return executeQuery(getMemberRef(dcOrVars, vars));
}

export const getMemberReferencesRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetMemberReferences', inputVars);
}
getMemberReferencesRef.operationName = 'GetMemberReferences';

export function getMemberReferences(dcOrVars, vars) {
  return executeQuery(getMemberReferencesRef(dcOrVars, vars));
}

export const getMemberByEmailRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetMemberByEmail', inputVars);
}
getMemberByEmailRef.operationName = 'GetMemberByEmail';

export function getMemberByEmail(dcOrVars, vars) {
  return executeQuery(getMemberByEmailRef(dcOrVars, vars));
}

export const addMemberRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'AddMember', inputVars);
}
addMemberRef.operationName = 'AddMember';

export function addMember(dcOrVars, vars) {
  return executeMutation(addMemberRef(dcOrVars, vars));
}

export const updateMemberRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'UpdateMember', inputVars);
}
updateMemberRef.operationName = 'UpdateMember';

export function updateMember(dcOrVars, vars) {
  return executeMutation(updateMemberRef(dcOrVars, vars));
}

export const softDeleteMemberRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'SoftDeleteMember', inputVars);
}
softDeleteMemberRef.operationName = 'SoftDeleteMember';

export function softDeleteMember(dcOrVars, vars) {
  return executeMutation(softDeleteMemberRef(dcOrVars, vars));
}

export const softDeleteMembersByOrganizationRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'SoftDeleteMembersByOrganization', inputVars);
}
softDeleteMembersByOrganizationRef.operationName = 'SoftDeleteMembersByOrganization';

export function softDeleteMembersByOrganization(dcOrVars, vars) {
  return executeMutation(softDeleteMembersByOrganizationRef(dcOrVars, vars));
}

export const getMiscSettingRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetMiscSetting', inputVars);
}
getMiscSettingRef.operationName = 'GetMiscSetting';

export function getMiscSetting(dcOrVars, vars) {
  return executeQuery(getMiscSettingRef(dcOrVars, vars));
}

export const upsertMiscSettingRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'UpsertMiscSetting', inputVars);
}
upsertMiscSettingRef.operationName = 'UpsertMiscSetting';

export function upsertMiscSetting(dcOrVars, vars) {
  return executeMutation(upsertMiscSettingRef(dcOrVars, vars));
}

export const getOrganizationByPhoneRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetOrganizationByPhone', inputVars);
}
getOrganizationByPhoneRef.operationName = 'GetOrganizationByPhone';

export function getOrganizationByPhone(dcOrVars, vars) {
  return executeQuery(getOrganizationByPhoneRef(dcOrVars, vars));
}

export const getPhoneByNumberRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetPhoneByNumber', inputVars);
}
getPhoneByNumberRef.operationName = 'GetPhoneByNumber';

export function getPhoneByNumber(dcOrVars, vars) {
  return executeQuery(getPhoneByNumberRef(dcOrVars, vars));
}

export const getMemberByPhoneRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetMemberByPhone', inputVars);
}
getMemberByPhoneRef.operationName = 'GetMemberByPhone';

export function getMemberByPhone(dcOrVars, vars) {
  return executeQuery(getMemberByPhoneRef(dcOrVars, vars));
}

export const getMemberByTextRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetMemberByText', inputVars);
}
getMemberByTextRef.operationName = 'GetMemberByText';

export function getMemberByText(dcOrVars, vars) {
  return executeQuery(getMemberByTextRef(dcOrVars, vars));
}

export const getPhonesRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetPhones', inputVars);
}
getPhonesRef.operationName = 'GetPhones';

export function getPhones(dcOrVars, vars) {
  return executeQuery(getPhonesRef(dcOrVars, vars));
}

export const getPhoneRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetPhone', inputVars);
}
getPhoneRef.operationName = 'GetPhone';

export function getPhone(dcOrVars, vars) {
  return executeQuery(getPhoneRef(dcOrVars, vars));
}

export const getAdminPhoneRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetAdminPhone', inputVars);
}
getAdminPhoneRef.operationName = 'GetAdminPhone';

export function getAdminPhone(dcOrVars, vars) {
  return executeQuery(getAdminPhoneRef(dcOrVars, vars));
}

export const getPhoneWithMessagesRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetPhoneWithMessages', inputVars);
}
getPhoneWithMessagesRef.operationName = 'GetPhoneWithMessages';

export function getPhoneWithMessages(dcOrVars, vars) {
  return executeQuery(getPhoneWithMessagesRef(dcOrVars, vars));
}

export const createPhoneRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'CreatePhone', inputVars);
}
createPhoneRef.operationName = 'CreatePhone';

export function createPhone(dcOrVars, vars) {
  return executeMutation(createPhoneRef(dcOrVars, vars));
}

export const updatePhoneRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'UpdatePhone', inputVars);
}
updatePhoneRef.operationName = 'UpdatePhone';

export function updatePhone(dcOrVars, vars) {
  return executeMutation(updatePhoneRef(dcOrVars, vars));
}

export const addPhoneNotesRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'AddPhoneNotes', inputVars);
}
addPhoneNotesRef.operationName = 'AddPhoneNotes';

export function addPhoneNotes(dcOrVars, vars) {
  return executeMutation(addPhoneNotesRef(dcOrVars, vars));
}

export const deletePhoneNotesRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'DeletePhoneNotes', inputVars);
}
deletePhoneNotesRef.operationName = 'DeletePhoneNotes';

export function deletePhoneNotes(dcOrVars, vars) {
  return executeMutation(deletePhoneNotesRef(dcOrVars, vars));
}

export const undeletePhoneRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'UndeletePhone', inputVars);
}
undeletePhoneRef.operationName = 'UndeletePhone';

export function undeletePhone(dcOrVars, vars) {
  return executeMutation(undeletePhoneRef(dcOrVars, vars));
}

export const createPhoneMessageRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'CreatePhoneMessage', inputVars);
}
createPhoneMessageRef.operationName = 'CreatePhoneMessage';

export function createPhoneMessage(dcOrVars, vars) {
  return executeMutation(createPhoneMessageRef(dcOrVars, vars));
}

export const updatePhoneMessageProcessedRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'UpdatePhoneMessageProcessed', inputVars);
}
updatePhoneMessageProcessedRef.operationName = 'UpdatePhoneMessageProcessed';

export function updatePhoneMessageProcessed(dcOrVars, vars) {
  return executeMutation(updatePhoneMessageProcessedRef(dcOrVars, vars));
}

export const getPhoneNumbersRef = (dc) => {
  const { dc: dcInstance} = validateArgs(connectorConfig, dc, undefined);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetPhoneNumbers');
}
getPhoneNumbersRef.operationName = 'GetPhoneNumbers';

export function getPhoneNumbers(dc) {
  return executeQuery(getPhoneNumbersRef(dc));
}

export const getPhoneNumberRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetPhoneNumber', inputVars);
}
getPhoneNumberRef.operationName = 'GetPhoneNumber';

export function getPhoneNumber(dcOrVars, vars) {
  return executeQuery(getPhoneNumberRef(dcOrVars, vars));
}

export const getPhoneNumberOrganizationsRef = (dc) => {
  const { dc: dcInstance} = validateArgs(connectorConfig, dc, undefined);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetPhoneNumberOrganizations');
}
getPhoneNumberOrganizationsRef.operationName = 'GetPhoneNumberOrganizations';

export function getPhoneNumberOrganizations(dc) {
  return executeQuery(getPhoneNumberOrganizationsRef(dc));
}

export const addPhoneNumberRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'AddPhoneNumber', inputVars);
}
addPhoneNumberRef.operationName = 'AddPhoneNumber';

export function addPhoneNumber(dcOrVars, vars) {
  return executeMutation(addPhoneNumberRef(dcOrVars, vars));
}

export const verifyPhoneNumberRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'VerifyPhoneNumber', inputVars);
}
verifyPhoneNumberRef.operationName = 'VerifyPhoneNumber';

export function verifyPhoneNumber(dcOrVars, vars) {
  return executeMutation(verifyPhoneNumberRef(dcOrVars, vars));
}

export const assignPhoneNumberRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'AssignPhoneNumber', inputVars);
}
assignPhoneNumberRef.operationName = 'AssignPhoneNumber';

export function assignPhoneNumber(dcOrVars, vars) {
  return executeMutation(assignPhoneNumberRef(dcOrVars, vars));
}

export const unassignPhoneNumberRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'UnassignPhoneNumber', inputVars);
}
unassignPhoneNumberRef.operationName = 'UnassignPhoneNumber';

export function unassignPhoneNumber(dcOrVars, vars) {
  return executeMutation(unassignPhoneNumberRef(dcOrVars, vars));
}

export const getUserRightsRef = (dc) => {
  const { dc: dcInstance} = validateArgs(connectorConfig, dc, undefined);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetUserRights');
}
getUserRightsRef.operationName = 'GetUserRights';

export function getUserRights(dc) {
  return executeQuery(getUserRightsRef(dc));
}

export const getAdminUserRightsRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetAdminUserRights', inputVars);
}
getAdminUserRightsRef.operationName = 'GetAdminUserRights';

export function getAdminUserRights(dcOrVars, vars) {
  return executeQuery(getAdminUserRightsRef(dcOrVars, vars));
}

export const getRightsByOrganizationRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetRightsByOrganization', inputVars);
}
getRightsByOrganizationRef.operationName = 'GetRightsByOrganization';

export function getRightsByOrganization(dcOrVars, vars) {
  return executeQuery(getRightsByOrganizationRef(dcOrVars, vars));
}

export const getInvitationsByOrganizationRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetInvitationsByOrganization', inputVars);
}
getInvitationsByOrganizationRef.operationName = 'GetInvitationsByOrganization';

export function getInvitationsByOrganization(dcOrVars, vars) {
  return executeQuery(getInvitationsByOrganizationRef(dcOrVars, vars));
}

export const getInvitationsByEmailRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'GetInvitationsByEmail', inputVars);
}
getInvitationsByEmailRef.operationName = 'GetInvitationsByEmail';

export function getInvitationsByEmail(dcOrVars, vars) {
  return executeQuery(getInvitationsByEmailRef(dcOrVars, vars));
}

export const upsertRightsRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'UpsertRights', inputVars);
}
upsertRightsRef.operationName = 'UpsertRights';

export function upsertRights(dcOrVars, vars) {
  return executeMutation(upsertRightsRef(dcOrVars, vars));
}

export const deleteRightsRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'DeleteRights', inputVars);
}
deleteRightsRef.operationName = 'DeleteRights';

export function deleteRights(dcOrVars, vars) {
  return executeMutation(deleteRightsRef(dcOrVars, vars));
}

export const addInvitationRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'AddInvitation', inputVars);
}
addInvitationRef.operationName = 'AddInvitation';

export function addInvitation(dcOrVars, vars) {
  return executeMutation(addInvitationRef(dcOrVars, vars));
}

export const deleteInvitationRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'DeleteInvitation', inputVars);
}
deleteInvitationRef.operationName = 'DeleteInvitation';

export function deleteInvitation(dcOrVars, vars) {
  return executeMutation(deleteInvitationRef(dcOrVars, vars));
}

export const acceptInvitationRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars, true);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'AcceptInvitation', inputVars);
}
acceptInvitationRef.operationName = 'AcceptInvitation';

export function acceptInvitation(dcOrVars, vars) {
  return executeMutation(acceptInvitationRef(dcOrVars, vars));
}

